__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/643624ba0af797900a8b70656a4a560d48b94795957b2c76a335f75f/";